import { render, staticRenderFns } from "./Garbage.vue?vue&type=template&id=e8c0f100&"
import script from "./Garbage.vue?vue&type=script&lang=ts&"
export * from "./Garbage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports